import { Component } from '@angular/core';

@Component({
  selector: 'app-overview',
  standalone: false,
  templateUrl: './overview.html',
  styleUrl: './overview.css',
})
export class Overview {

  stats = {
    users: 1248,
    subjects: 6,
    quizzes: 342,
    syncStatus: 'Online'
  };

}